import React, { useState, useEffect } from 'react'
import { Api } from 'services';

// Served straight out of public/, so it stays same-origin and needs no router/bundle entry.
const PAYU_LOADING_URL = `${process.env.PUBLIC_URL || ''}/payu-loading.html`;

export const openPayuLoadingWindow = (windowName) => {
  // Load the loading page by URL rather than writing markup into the window. This keeps a
  // brand-new tab and a re-used one pixel-identical, and it never touches the window's
  // document -- so re-using a tab that has already navigated to PayU (and is therefore
  // cross-origin) can't throw a SecurityError. Navigating a cross-origin window by name is
  // permitted; only reading from it is blocked.
  return window.open(PAYU_LOADING_URL, windowName);
};

export const redirectToPayU = (data, targetWindowName = "_blank") => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = data.payuBaseUrl;
  form.target = targetWindowName;
  form.rel = "noreferrer";

  const fields = {
    key: data.key,
    txnid: data.txnid,
    amount: data.amount,
    productinfo: data.productinfo,
    firstname: data.firstname,
    email: data.email,
    phone: data.phone,
    surl: data.surl,
    furl: data.furl,
    hash: data.hash,
    udf1: data.udf1,
    udf2: data.udf2,
    udf3: data.udf3,
    udf4: data.udf4,
    udf5: data.udf5,
  };
  // Present only on split (aggregator) orders; the backend has already hashed this exact string.
  if (data.splitRequest) {
    fields.splitRequest = data.splitRequest;
  }

  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value ?? "";
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
};

export const generatePaymentRequest = (response, record, userDetails, fromMarket) => {
 console.log("record",record);
  const cashfree = Cashfree({
    mode: "production", // or "production"
    // other configuration options
  });

  console.log({ cashfree });
  console.log({ response });
  let checkoutOptions = {
    paymentSessionId: response?.payment_session_id,
    returnUrl:`${Api?._base_url}/redirect-to?orderId=${response?.order_id}&id=${record?.transactionId}&userId=${userDetails?.id}&fromMarket=${fromMarket}`,
    // redirectTarget: "_blank",
  }

  console.log({ checkoutOptions });

  cashfree.checkout(checkoutOptions).then(function (result) {
    console.log({ result });

    if (result.error) {
      alert(result.error.message)
    }
    if (result.redirect) {
      console.log("Redirection")
      
    }
  });

 
  let options = {
    values: {
      upiId: ""
    }
  };

  let component = cashfree.create("upiCollect", options);
  console.log({ component });

  const div = document.createElement('div');
  div.setAttribute("id", "componentContainer");
  document.body.appendChild(div);

  component.mount("#componentContainer");



  let paymentOptions = {
    paymentMethod: component,
    paymentSessionId: response?.payment_session_id,
    returnUrl: `${Api?._base_url}/payment-success/?orderId=${response?.order_id}&id=${record?.transactionId}&userId=${userDetails?.id}`,

  };

  console.log({ paymentOptions });

  cashfree.pay(paymentOptions).then(function (result) {
    console.log({ result });
    if (result.error) {
      //there is an error
      //message at result.error.message
    }
    if (result.cancelled) {
      // User cancelled the payment
      // Close the tab or perform any other action
      window.close();
    }
    if (result.redirect) {
      
    }
    if (result.paymentDetails) {
      //only when redirect = 'if_required' for UPI payment
      //payment is successful 
      //message is at result.paymentDetails.paymentMessage
    }
  });

}

// try {
//   const result = await cashfree.pay(checkoutOptions);
//   console.log("AAA-after  pay", result);

//   // Handle the payment result
//   if (result.error) {
//     // Handle payment error
//     alert(result.error.message);
//   } else if (result.cancelled) {
//     // User cancelled the payment
//     // Close the tab or perform any other action
//     window.close();
//   } else {
//     // Payment was successful
//     console.log('Payment successful');

//     // Call the API after successful payment
//     callYourApiFunction(response, record, userDetails);
//   }
// } catch (error) {
//   // Handle other errors
//   console.error('Error during payment:', error);
// }



// // ... (rest of the code)
// };